import './OfferList.less';
import OfferBox from '../../components/OfferBox/OfferBox';
import TopFilter from '../../components/TopFilter/TopFilter';


import Page from '../../hoc/Page.js';

const OfferList = () =>{
	
	const scrollToResult = () => {
		let ele = document.getElementById('searchResult');
		window.scrollTo(ele.offsetLeft,ele.offsetTop-100);
	}
	
	const boot = () => {
		scrollToResult();
	};
	
	boot();
	
};

export default Page(OfferList);